module.exports = __webpack_public_path__ + "img/right-6.4d158729.png";